import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { addAdditionalBreadcrumbParams } from 'Store';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import errorController from 'Components/ErrorScreens';
import Layout from 'Components/Layout';
import RouteLoading from 'Components/RouteLoading';
import EditExpressionForm from 'Components/EditExpressionForm';

const EditExpression = () => {
    const { parameterId } = useParams<{ parameterId: string }>();
    // Expression service requires all parameters except the current parameter
    // to be passed in "modelFields" to validate user's script
    const parametersAPI = useGetParameters({});
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        if (parametersAPI?.data && parameterId) {
            dispatch(
                addAdditionalBreadcrumbParams({
                    pathname: location.pathname,
                    params: {
                        parameterName: parametersAPI.data.idHashmap[Number(parameterId)].message
                    }
                })
            );
        }
    }, [location, parametersAPI, dispatch, parameterId]);

    if (parametersAPI.isLoading || parametersAPI.isFetching) return <RouteLoading />;
    if (parametersAPI.isError) {
        const { errorCmp } = errorController([parametersAPI.error]);
        return errorCmp;
    }

    const currentParameter = parametersAPI?.data?.idHashmap[Number(parameterId)];
    const initialValues: PatchExpParamFormSchema = {
        // set an arbitrary id value if not present
        id: currentParameter?.id ?? -1,
        displayName: currentParameter?.message ?? '',
        systemName: currentParameter?.fieldName ?? '',
        description: currentParameter?.description ?? '',
        expression: {
            expText: currentParameter?.expressionStatement ?? '',
            inputs: {},
            functionCalls: []
        },
        isScriptValidated: false,
        tppType: currentParameter?.tppType,
        status: currentParameter?.status
    };

    return (
        <Layout>
            <EditExpressionForm initialValues={initialValues} parameterData={parametersAPI.data} />
        </Layout>
    );
};

export default EditExpression;
